/**
 *
 * v.1.0  08/09/25  Inicial
 * v.1.1  11/09/25 Formateada la fecha de la barra en la nueva variable labelFormateada.
 *                 Modificada la llamada a DateTimePicker para que salga en ES y salga un periodo de años definido.
 **/


import React, { useState } from 'react';
import 'moment/locale/es'; // Importa la localización de español
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import {DatePicker} from "@blueprintjs/datetime";
import moment from "moment";
import {DateFormatStrings} from "../../blueprint/DayPickerProps";



class
CalendarioToolbar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showPicker: false
        }

        this.buttonRef = React.createRef();

    }

    handleDateChange = (date) => {
        this.setState({ showPicker: false });
        this.props.onNavigate('DATE', date);
    };
    render() {
        const { label, date, onNavigate, onView } = this.props;
        const {showPicker} = this.state;
        //console.log("CalendarioToolbar Render");
        //console.log("label: ", label);

        let labelFormateada=  moment(date).format("D MMMM YYYY");
        return (
            <div
                className="rbc-toolbar"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "relative"
                }}
            >
                {/* Botones prev/hoy/next */}
                <span className="rbc-btn-group">
                    <button type="button" onClick={() => onNavigate('PREV')}>◀</button>
                    <button type="button" onClick={() => onNavigate('TODAY')}>Hoy</button>
                    <button type="button" onClick={() => onNavigate('NEXT')}>▶</button>
                </span>


                {/* Label clicable con popover */}
                <span style={{ position: "relative", display: "inline-block" }}>
                      <span
                          style={{ cursor: "pointer", fontWeight: "bold" }}
                          onClick={() => this.setState({ showPicker: !showPicker })}
                      >
                          {labelFormateada}
                      </span>

                     {this.state.showPicker && (
                        <div
                            style={{
                                position: "absolute",
                                top: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                zIndex: 9999,
                                background: "white",
                                boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                                borderRadius: "8px",
                                padding: "4px",
                                marginTop: "8px", // espacio para la flechita
                            }}
                        >
                            {/* Flechita */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-8px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: 0,
                                    height: 0,
                                    borderLeft: "8px solid transparent",
                                    borderRight: "8px solid transparent",
                                    borderBottom: "8px solid white",
                                    filter: "drop-shadow(0 -1px 1px rgba(0,0,0,0.1))",
                                }}
                            />

                            <DatePicker
                                inline
                                minDate={new Date(2000, 0, 1)}    // desde 2000
                                maxDate={new Date(2035, 11, 31)}  // hasta 2035
                                highlightCurrentDay={true}
                                dayPickerProps= { DateFormatStrings  }
                                selected={new Date(date)}
                                onChange={this.handleDateChange}
                                initialMonth={new Date(date)}
                            />
                        </div>
                    )}
                </span>

















                {/* 👇 Título clicable */}
                {/*}
                <span
                    ref={this.buttonRef}
                    style={{ cursor: "pointer", fontWeight: "bold" }}
                    onClick={() => this.setState({ showPicker: !showPicker })}
                >
                    {label}
                </span>
                */}
                {/* Popover flotante */}
                { /* showPicker && (
                    <div
                        style={{
                            position: "absolute",
                            top: "100%", // debajo del toolbar
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 9999,
                            background: "white",
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                            borderRadius: "8px",
                            padding: "4px"
                        }}
                    >
                        <DatePicker
                            selected={new Date(date)}
                            onChange={this.handleDateChange}
                            inline
                        />
                    </div>
                )*/}

                {/* Botones de cambio de vista */}
                <span className="rbc-btn-group">
                    <button type="button" onClick={() => onView('day')}>Día</button>
                    <button type="button" onClick={() => onView('week')}>Semana</button>
                    <button type="button" onClick={() => onView('work_week')}>Semana laboral</button>
                    <button type="button" onClick={() => onView('month')}>Mes</button>
                </span>
            </div>
        );
    }

}

export default CalendarioToolbar